import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=ec2b38a0&scoped=true&"
import script from "./Hotels.vue?vue&type=script&lang=ts&"
export * from "./Hotels.vue?vue&type=script&lang=ts&"
import style0 from "./Hotels.vue?vue&type=style&index=0&id=ec2b38a0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b38a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
